import React from 'react';
import { classNames } from '../../utils/format';

const ICONS = { info: 'ℹ', warning: '⚠', danger: '!', success: '✓' };

export default function Callout({ tone = 'info', title, children, className }) {
  return (
    <div className={classNames('callout', `callout--${tone}`, className)} role={tone === 'danger' ? 'alert' : 'note'}>
      <span className="callout__icon" aria-hidden>{ICONS[tone] || ICONS.info}</span>
      <div className="callout__body">
        {title && <div className="callout__title">{title}</div>}
        {children && <div className="callout__text">{children}</div>}
      </div>
    </div>
  );
}
